import { AutoScaleDim } from '../../../../../../models/autoScale'

const OVERLAY_KEY = 'autoScaleDimensionsOverlay'
const DIMENSION_KEY = 'autoScaleDimension'
const DIMENSION_COLOR = '#159a38'

export const removeAutoScaleOverlay = (paper: paper.PaperScope): void => {
    paper.project?.getItems({ data: (data: any) => data?.[OVERLAY_KEY] === true }).forEach((item) => item.remove())
}

export const drawAutoScaleOverlay = (paper: paper.PaperScope, dims: AutoScaleDim[]): paper.Group | null => {
    removeAutoScaleOverlay(paper)

    if (!paper.project || !dims.length) return null

    const lines = dims.map((dim) => {
        const line = new paper.Path({
            segments: [dim.p1, dim.p2],
            strokeColor: DIMENSION_COLOR,
            strokeWidth: 3,
            strokeCap: 'round',
            insert: false,
        })

        line.strokeScaling = false
        line.data = { [DIMENSION_KEY]: dim.id }

        return line
    })
    const group = new paper.Group({ children: lines, insert: false })

    group.data = { [OVERLAY_KEY]: true }
    group.locked = true

    const [mainRaster] = paper.project.getItems({ data: (data: any) => data?.isMainRaster === true })

    if (mainRaster) group.insertAbove(mainRaster)
    else paper.project.activeLayer.addChild(group)

    return group
}
